import { combineReducers } from "redux";
import { reducer as formReducer } from 'redux-form';
import { snackbarReducer } from 'react-redux-snackbar';
import { loadingBarReducer } from 'react-redux-loading-bar';
import Login from './Auth/LoginReducer'
import Forget from './Auth/ForgetReducer'
import Language from './LanguageReducer'
import Chat from './ChatReducer'
import Levlel from './Teacher/levelsReducer'
import Assign from './AssignReducer'

export default combineReducers({
   form: formReducer,
   snackbar: snackbarReducer,
   loadingBar: loadingBarReducer,
   login: Login,
   forget: Forget,
   lang: Language,
   chat: Chat,
   Levlel:Levlel,
   assign: Assign,

});
